import {CommandBase} from "./CommandBase";
import {CommandManager} from "../libs/CommandManager";
import {Asset} from "../entities/Asset";

export class CommandGetPositionDirective extends CommandBase implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdgetposition.html').default;
    scope = {
        map : "=",
        selectedItems : "=",
        commandEnabled : "="
    };
    areaSelect:any;
    constructor(commandManager:CommandManager) {
        super(commandManager);
    }
    controller = ['$scope',($scope:any)=>{
        $scope.vm = this;
        $scope.$watch(()=>$scope.selectedItems.length, (newVal:any)=> {
            this.selectedItems = $scope.selectedItems;
        });
    }]
    getCommandText(asset:Asset):string{
        return asset.vTagID;
    }
    getCommandType():string{
        return "Get Position";
    }
    static factory():ng.IDirectiveFactory {
        var directive = (commandManager:CommandManager) => {
            return new CommandGetPositionDirective(commandManager);
        }
        directive.$inject = ['CommandManager'];
        return directive;
    }
}
